import { useState } from 'react';

import { FilterChipOption } from '../models/filter-chip-option';

export type MultiValueFilterChipProps = {
  options: FilterChipOption[];
  onOptionsSelected: (keys: string[]) => void;
  placeHolder: string;
  selectedOptions: FilterChipOption[];
  disabled?: boolean;
};

type MultiValueFilterChip = {
  isOpen: boolean;
  close: () => void;
  toggleIsOpen: () => void;
  handleOnCheckboxChanged: (option: FilterChipOption) => void;
  getLabel: () => string;
  sortedOptions: FilterChipOption[];
  selectedOptions: FilterChipOption[];
  placeHolder: string;
};

export const useMultiValueFilterChip = ({
  options,
  onOptionsSelected,
  placeHolder,
  selectedOptions,
}: Readonly<MultiValueFilterChipProps>): MultiValueFilterChip => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = (): void => setIsOpen((prev) => !prev);
  const close = (): void => setIsOpen(false);

  const handleOnCheckboxChanged = (option: FilterChipOption): void => {
    const currentSelectedValues = selectedOptions.flatMap((opt) => opt.value);
    const selectedIndex = currentSelectedValues.findIndex((value) => option.value.includes(value));

    const selectedValue =
      selectedIndex === -1
        ? [...currentSelectedValues, ...option.value]
        : currentSelectedValues.filter((value) => !option.value.includes(value));

    onOptionsSelected(selectedValue);
  };

  const getLabel = (): string =>
    selectedOptions.length > 0 ? selectedOptions.map((selectedOption) => selectedOption.label).join(', ') : placeHolder;

  const sortedOptions = [...options].sort((a, b) => a.label.localeCompare(b.label));

  return {
    isOpen,
    close,
    toggleIsOpen,
    handleOnCheckboxChanged,
    getLabel,
    sortedOptions,
    selectedOptions,
    placeHolder,
  };
};
